// 迎宾签到区 + 舞台仪式区 + 婚礼细节
import { Button, Radio } from 'hljd'
import { inject, observer } from 'mobx-react'
import React, { useState } from 'react'
import OperableArea from '../../common/OperableArea'
import Image from '../../components/Image'
import Title from '../../components/Title'
import { MAIN_AREA } from '../../constants'
import { getCaseImageTag } from '../../utils'

const PictureShow = ({ title, imgs, contentStore, kind, caseImageTag }) => {
  const { setActive, active, list } = contentStore
  const [selectedTag, setSelectedTag] = useState()
  const [selectedArea, setSelectedArea] = useState(kind)

  const up = index => {
    const left = imgs[index - 1]
    if (left) {
      imgs[index - 1] = imgs[index]
      imgs[index] = left
    }
  }

  const down = index => {
    const right = imgs[index + 1]
    if (right) {
      imgs[index + 1] = imgs[index]
      imgs[index] = right
    }
  }

  const remove = index => {
    imgs.splice(index, 1)
  }

  const onSave = (img, index) => {
    img.markId = selectedTag
    if (selectedArea !== kind) {
      const areaIndex = list.findIndex(f => f?.kind === selectedArea)
      list[areaIndex].imgs.push(img)
      remove(index)
      setActive()
    }
  }

  return !!imgs.length ? (
    <>
      <div style={{ padding: '0 16px' }}>
        <Title title={title} />
      </div>
      {imgs?.map((img, index) => (
        <OperableArea
          imgs={imgs}
          key={index}
          index={index}
          title="图片区域和标签"
          actionRender={
            <div style={{ padding: '12px 16px' }}>
              <label
                className="required"
                style={{ marginBottom: 8, display: 'block' }}
              >
                区域
              </label>
              <Radio.Group
                value={selectedArea}
                onChange={e => {
                  setSelectedTag()
                  setSelectedArea(e.target.value)
                }}
              >
                {MAIN_AREA.map(area => (
                  <Radio key={area.value} value={area.value}>
                    {area.label}
                  </Radio>
                ))}
              </Radio.Group>
              <label style={{ margin: '8px 0', display: 'block' }}>标签</label>
              <Radio.Group
                onChange={e => setSelectedTag(e.target.value)}
                value={selectedTag}
              >
                {getCaseImageTag(caseImageTag, selectedArea).map(t => (
                  <Radio key={t.id} value={t.id}>
                    {t.name}
                  </Radio>
                ))}
              </Radio.Group>
              <div>
                <Button
                  onClick={() => onSave(img, index)}
                  style={{ marginTop: 16 }}
                  type="primary"
                >
                  保存
                </Button>
              </div>
            </div>
          }
          id={img.id}
          onClick={id => {
            setActive(id)
            setSelectedTag(img?.markId)
            setSelectedArea(kind)
          }}
          active={active}
          style={{ padding: '0 16px', marginBottom: 4 }}
          quickAction={['up', 'down', 'remove']}
          up={() => up(index)}
          down={() => down(index)}
          remove={() => remove(index)}
        >
          <Image
            src={img.url}
            tagText={
              getCaseImageTag(caseImageTag, kind).find(f => f.id === img.markId)
                ?.name
            }
          />
        </OperableArea>
      ))}
    </>
  ) : null
}

export default inject('contentStore')(observer(PictureShow))
